import React, { Component } from 'react'

class Index extends Component {
  render() {
    return <>
      This is my old website last updated in 2019. Feel free to explore!
      <br/>
      Afterwards, join me at my new website: <a href="https://shilangyu.dev">shilangyu.dev</a>
    </>
  }
}

export default Index
